/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
export {default as ServicesV2} from './services-v2';
export {default as ServiceCatalogV2} from './service-catalog';
export {default as ServiceDetail} from './service-detail';
